import { apiCustomFields } from "@/api/custom-fields.api.ts";
import { CustomFieldRendererProps } from "@/components/custom-field/edit/custom-field-edit.type.ts";
import useErrorHandle from "@/hooks/use-error-handle.hook.tsx";
import usePermissions from "@/hooks/use-permissions.hook.ts";
import { ApiCFEntityTypes, ApiFieldTypes } from "@/types/custom-field.types.ts";
import { ApiPermission } from "@/types/role.types.ts";
import { ApiFeatureType } from "@/types/subscription.types.ts";
import { CustomFieldSelect } from "@skailer-com/uikit";
import { useState } from "react";

/** Выбор из опций поля; с правом на настройку полей новую опцию можно добавить прямо из списка. */
export function CustomFieldEditSelect(props: CustomFieldRendererProps) {
  const { field, options } = props;
  const { canIEdit, isFeatureEnabled } = usePermissions();
  const { handleErrors } = useErrorHandle();
  const [fieldOptions, setFieldOptions] = useState(field.options ?? []);

  const canCreateOption =
    !options &&
    field.type === ApiFieldTypes.custom &&
    canIEdit(ApiPermission.manage_custom_fields) &&
    isFeatureEnabled(ApiFeatureType.custom_fields);

  const createOption = async (title: string) => {
    const updatedOptions = [...fieldOptions, { title, description: "" }];
    const response =
      field.entity_type === ApiCFEntityTypes.employee_table
        ? await apiCustomFields.updateTableField(field.table_id, field.id, {
            field_type: field.field_type,
            title: field.title,
            is_mandatory: field.is_mandatory,
            is_hidden: field.is_hidden,
            description: field.description,
            hint: field.hint,
            config: field.config ?? { is_multiple_values: false },
            options: updatedOptions,
          })
        : await apiCustomFields.updateField(field.id, { options: updatedOptions });

    if (!response.data) {
      handleErrors(response.error);
      return undefined;
    }

    const resultOptions = response.data.options;
    setFieldOptions(resultOptions);
    return resultOptions.find((option) => option.title === title)?.id;
  };

  return (
    <CustomFieldSelect {...props} onCreateOption={canCreateOption ? createOption : undefined} />
  );
}
